const captchaPublicKey = process.env.REACT_APP_CAPTCHA_PUBLIC_KEY
const basename = "/app"

// Both are injected at build time by .forgejo/workflows/tablews-app.yml
// from SSM (/${env}/tablews/{authDomain,projectDomainId}). Read through
// here rather than off process.env at the point of use, so every consumer sees
// the same value and the build-time contract lives in one file.
const authDomain = process.env.REACT_APP_AUTH_DOMAIN
const projectDomainId = process.env.REACT_APP_PROJECT_DOMAIN_ID

// The distribution's own *.cloudfront.net name — what a tenant's edge must send
// a composed page's request to, and the one value the Domains screen's setup
// instructions cannot derive from anything else it knows.
//
// It cannot be the app's hostname: the renderer refuses to answer when the
// viewer's host is this app's domain, which is what keeps tenant-authored script
// off the origin holding the editor's session (P142). So it is the cdn stack's
// DistributionDomainName, injected at build time.
//
// UNDEFINED IS A VALID STATE and the screen handles it: a local checkout has no
// distribution at all, and an environment whose cdn stack has not been deployed
// yet has no such output. The three builders that write it — tablews-app.yml,
// branch-env.sh and local/envs — all resolve it non-fatally for that reason. An
// app must never fail to build because a hostname could not be looked up.
const sitesOrigin = process.env.REACT_APP_SITES_ORIGIN

// CloudWatch RUM. Injected at build time by .forgejo/workflows/*-app.yml from
// the outputs of the ${env}-repoflow-system-observability-stack. All three are
// undefined in local dev, which leaves RUM inert — see
// @repoflow/components/observability.
const rum = {
    applicationId: process.env.REACT_APP_RUM_APP_MONITOR_ID,
    identityPoolId: process.env.REACT_APP_RUM_IDENTITY_POOL_ID,
    region: process.env.REACT_APP_RUM_REGION,
    // Baked from the app monitor's SessionSampleRate. The client samples on
    // its own side, so without this every session is recorded regardless of
    // what the monitor says. Absent or unparseable falls back to the client
    // default (1) — only reachable when RUM is inert anyway.
    sessionSampleRate: Number.isFinite(parseFloat(process.env.REACT_APP_RUM_SESSION_SAMPLE_RATE))
        ? parseFloat(process.env.REACT_APP_RUM_SESSION_SAMPLE_RATE)
        : undefined,
}

export {
    captchaPublicKey,
    basename,
    authDomain,
    projectDomainId,
    sitesOrigin,
    rum
}
